export default {
  "content": "<path d=\"M12 18a1.5 1.5 0 110 3 1.5 1.5 0 010-3zM12 2c3.45 0 6 2.613 6 5.92 0 1.67-.68 3.047-1.798 4.014-.876.758-1.991 1.238-3.202 1.452V16h-2v-4.44l.938-.058c1.226-.077 2.254-.474 2.956-1.081C15.577 9.83 16 9.004 16 7.92 16 5.72 14.35 4 12 4 9.605 4 7.93 5.77 7.483 8.108l-1.965-.376C6.096 4.705 8.409 2 12 2z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};